/**************************************************
 * Nombre:       Tarjeta_Imagen_Reserva
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import 'react-medium-image-zoom/dist/styles.css'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {obtenerValorReservaTotal} from "../../CodigoNegocio/obtenerValorReservaTotal";
import {obtenerDiasPromocion} from "../../CodigoNegocio/obtenerDiasPromocion";
import {obtenerValorReserva} from "../../CodigoNegocio/obtenerValorReserva";
import {useEffect, useState} from "react";

const Tarjeta_Imagen_Reserva = ({item, numNoches, fechaCheckIn}) => {
    const {sCell} = useResponsive()
    const [valorTotal, setValorTotal] = useState(0)
    const [valorReservas, setValorReservas] = useState(0)
    const [numDiasPromo, setNumDiasPromo] = useState(0)

    useEffect(() => {

        let diasPromo = obtenerDiasPromocion({
            fechaCheckIn: fechaCheckIn,
            numNoches: numNoches,
            diasPromo: item.diasPromo
        })
        setNumDiasPromo(diasPromo)

        let valorTotal = obtenerValorReservaTotal({
            numNoches: numNoches,
            habitacion: item,
            numDiasPromo: diasPromo
        })
        setValorTotal(valorTotal)

        let valor = obtenerValorReserva(numNoches, item)
        setValorReservas(valor)

    }, [item])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 54.67%, #000 86.54%), url(${item.img})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: 320
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        background: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 54.67%, #000 86.54%)",
                        color: '#fff',
                        p: 3
                    }}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 28, fontWeight: 800}}>{`Suite ${item.numero}`}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                        <Typography sx={{
                            fontSize: 14,
                            fontWeight: 600
                        }}>{`Valor Suite: ${valorReservas} USD (por ${numNoches} Noches)`}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0, mb: 1}}>
                        <Typography sx={{
                            fontSize: 14,
                            fontWeight: 600
                        }}>{`Descuento : ${valorTotal - valorReservas} USD (por ${numDiasPromo} Dias con descuento)`}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 0, borderTop: 1, borderColor: '#fff', pt: 1}}>
                        <Typography sx={{
                            fontSize: 20,
                            fontWeight: 800
                        }}>{`Valor Total Reserva : ${valorTotal} USD`}</Typography>
                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Imagen_Reserva